<ng-template #errorCampo let-ruta="ruta">
  <div class="cf-field__error" [class.m182d-aviso]="m.type === 'WARNING'" *ngIf="mensaje(ruta) as m">
    <mat-icon>{{ m.type === 'WARNING' ? 'warning' : 'error' }}</mat-icon> {{ m.message }}
  </div>
</ng-template>

<ng-template #texto let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-max="max" let-span="span">
  <div class="m182d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'declarados.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, maxLength: max }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #numero let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-entero="entero" let-span="span">
  <div class="m182d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'declarados.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: entero ? '1' : '0.01', inputmode: entero ? 'numeric' : 'decimal' }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #seleccion let-ruta="ruta" let-etiqueta="etiqueta" let-opciones="opciones" let-requerido="requerido" let-span="span">
  <div class="m182d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-select [attr.id]="'declarados.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: opciones, placeholder: 'Seleccionar' }"></app-select>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>volunteer_activism</mat-icon>
    </div>
    <div class="m182d-header-text">
      <h2 class="cf-dlg-title">{{ titulo }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitulo }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cerrar()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" message="Guardando el declarado…"></app-loading-state>

  <ng-container *ngIf="!saving">
    <div class="cf-dlg-body">

      <div class="m182d-alert m182d-alert--error" *ngIf="sueltas.length">
        <mat-icon>error</mat-icon>
        <div>
          <div *ngFor="let item of sueltas; trackBy: trackByIndex">{{ item.message }}</div>
        </div>
      </div>

      <fieldset class="m182d-fs">

        <div class="m182d-box">
          <h6 class="m182d-box__title">Datos del declarado</h6>
          <div class="m182d-grid">
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nif', etiqueta: 'NIF del declarado', requerido: true, max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifRepresentante', etiqueta: 'NIF del representante legal', max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombre', etiqueta: 'Apellidos y nombre o razón social', requerido: true, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'provincia', etiqueta: 'Provincia', opciones: provinciaOptions, requerido: true, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'naturalezaDeclarado', etiqueta: 'Naturaleza del declarado', opciones: naturalezaOptions, span: 4 }"></ng-container>
          </div>
        </div>

        <div class="m182d-box">
          <h6 class="m182d-box__title">Donativo, aportación o disposición</h6>
          <div class="m182d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'clave', etiqueta: 'Clave', opciones: claveOptions, requerido: true, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'importe', etiqueta: 'Importe o valoración', requerido: true, span: 3 }"></ng-container>
            <div class="m182d-field" style="grid-column: span 3;" [class.cf-field--invalid]="!!mensaje('especie')">
              <app-select id="declarados.especie" [ngModel]="f.especieSN" (ngModelChange)="f.especieSN = $event"
                [config]="{ label: 'En especie', options: sinoOptions }"></app-select>
            </div>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'porcentajeDeduccion', etiqueta: 'Porcentaje de deducción', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'recurrencia', etiqueta: 'Recurrencia', opciones: recurrenciaOptions, span: 6 }"></ng-container>
          </div>
        </div>

        <div class="m182d-box">
          <h6 class="m182d-box__title">Revocación de donaciones</h6>
          <div class="m182d-grid">
            <div class="m182d-field" style="grid-column: span 3;">
              <app-select id="declarados.revocacion" [ngModel]="f.revocacionSN" (ngModelChange)="f.revocacionSN = $event"
                [config]="{ label: 'Revocación', options: sinoOptions }"></app-select>
            </div>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'ejercicioRevocada', etiqueta: 'Ejercicio de la donación revocada', entero: true, span: 3 }"></ng-container>
          </div>
        </div>

        <div class="m182d-box">
          <h6 class="m182d-box__title">Deducción autonómica</h6>
          <div class="m182d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'ccaa', etiqueta: 'Comunidad autónoma', opciones: ccaaOptions, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'porcentajeCcaa', etiqueta: 'Porcentaje de deducción autonómica', span: 3 }"></ng-container>
          </div>
        </div>

        <div class="m182d-box">
          <h6 class="m182d-box__title">Aportaciones y disposiciones en especie (claves C y D)</h6>
          <div class="m182d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoBien', etiqueta: 'Tipo de bien', opciones: tipoBienOptions, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'identificacionBien', etiqueta: 'Identificación del bien (NRC o ISIN)', max: 20, span: 5 }"></ng-container>
          </div>
        </div>

        <div class="m182d-box">
          <h6 class="m182d-box__title">Patrimonio protegido</h6>
          <div class="m182d-grid">
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifTitular', etiqueta: 'NIF del titular', max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombreTitular', etiqueta: 'Apellidos y nombre del titular', span: 6 }"></ng-container>
          </div>
        </div>

      </fieldset>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cerrar()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="guardar()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>
</div>
